export const rewindSpeedControlAttribute = {
  attributeKey: 'REWIND_SPEED_CONTROLS',
  attributeValue: 'TRUE',
};

export const userMarketIDsAttribute = {
  attributeKey: 'USER_MARKET_IDS',
  attributeValue: '[]',
};
